<h1>{{ dog?.name }} igazolvány készítő</h1>

<button id="documents-nav-button" mat-icon-button
  [routerLink]="['/dog', 'documents', { dogId: dogId, dogName: dog?.name }]" matTooltip="Dokumentumok/iratok">
  <mat-icon>folder</mat-icon>
</button>

<mat-button-toggle-group name="idcardType" [value]="selectedIdCardType" (change)="idCardTypeChange($event)">
  <mat-button-toggle value="facility">Terápiás kutya</mat-button-toggle>
  <mat-button-toggle value="service">Segítő kutya</mat-button-toggle>
  <mat-button-toggle value="service_training">Segítő tanuló kutya</mat-button-toggle>
</mat-button-toggle-group>

<div id="document-action-buttons">
  @if (canDownload()) {
  <button mat-stroked-button type="button" (click)="downloadCard()">
    <mat-icon>download</mat-icon>
    Letöltés (teljes felbontás)
  </button>
  }

  <div id="save-container">
    @if (mappedDocumentType) {
    <button mat-raised-button color="primary" type="button" [disabled]="!canSaveAndUpload() || isSaving"
      (click)="saveAndUpload()">
      {{ isSaving ? 'Mentés folyamatban...' : 'Mentés és feltöltés' }}
    </button>
    @if (isSaving) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
    } @else if (selectedIdCardType) {
    <p>Ehhez a típushoz nincs dokumentum feltöltés</p>
    }
  </div>
</div>

<h3>Kutya profil kép</h3>
<div id="profile-container">
  <div>
    <app-image-upload [width]="400" [height]="400" (onImage)="dogImageSelected($event)"></app-image-upload>
  </div>
  <div id="text-fields-row">
    <mat-form-field appearance="fill">
      <mat-label>Kiképző neve</mat-label>
      <input matInput [formControl]="trainerNameControl" />
      <mat-error>Kötelező mező</mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>Sorszám</mat-label>
      <input matInput [formControl]="idCardNumberControl" placeholder="Fromátum: FD-XXXX-ÉÉ"/>
      <mat-error>Kötelező mező</mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>Érvényesség vége</mat-label>
      <input matInput [formControl]="idCardExpiryControl" />
      <mat-error>éééé.hh.nn formátum (pl. 2022.10.08)</mat-error>
    </mat-form-field>
  </div>
</div>

<div #container id="container"></div>